import React from 'react'
import {
  Container,
  Message,
} from 'semantic-ui-react'
import {
  Link,
} from 'react-router-dom'

const SelectionDoesNotExist = ({id}) => (
  <Container text style={{ marginTop: '7em', padding: '10px', background: 'white #fef0e7' }}>
    <Message negative>
      <Message.Header>Do you have the right URL?</Message.Header>
      <p>There is no selection with ID <strong>{id}</strong>.</p>
      <p>Check out the <Link to="/selections">table with all selections</Link>.</p>
    </Message>
  </Container>
)

export default SelectionDoesNotExist